// Adapted from browser-bunyan's console-formatted-stream
import { DEBUG, ERROR, FATAL, INFO, TRACE, WARN } from 'browser-bunyan';
import { format } from 'date-fns';

const css = {
    levels: {
        trace: 'color: DeepPink',
        debug: 'color: GoldenRod',
        info: 'color: DarkTurquoise',
        warn: 'color: Purple',
        error: 'color: Crimson',
        fatal: 'color: Black',
    },
    default: 'color: DimGray',
    msg: 'color: SteelBlue',
    class: 'color: DimGray; font-style: italic; font-size: 0.9em',
};

export class CustomConsoleFormattedStream {
    private logByLevel: boolean;

    public constructor({ logByLevel = false } = {}) {
        this.logByLevel = logByLevel;
    }

    public write(rec: Record<string, unknown>): void {
        let levelCss = css.levels.info;
        let consoleMethod = console.log;

        const {
            childName,
            component,
            level: _level,
            levelName: _levelName,
            msg: _msg,
            name,
            time: _time,
            ...rest
        } = rec;
        const level = _level as number;
        const time = _time as Date;

        const loggerName = childName ? `${name}/${childName}` : rec.name;

        let levelName: string = (_levelName as string | undefined) ?? 'unknown';
        const formattedLevelName = (Array(6 - levelName.length).join(' ') + levelName).toUpperCase();

        if (this.logByLevel) {
            if (level === TRACE) {
                levelName = 'debug';
            } else if (level === FATAL) {
                levelName = 'error';
            }
            switch (levelName) {
                case 'trace':
                case 'debug':
                case 'info':
                case 'warn':
                case 'error':
                    consoleMethod = console[levelName];
                    break;
                default:
                    consoleMethod = console.log;
                    break;
            }
        } else {
            consoleMethod = console.log;
        }

        if (level < DEBUG) {
            levelCss = css.levels.trace;
        } else if (level < INFO) {
            levelCss = css.levels.debug;
        } else if (level < WARN) {
            levelCss = css.levels.info;
        } else if (level < ERROR) {
            levelCss = css.levels.warn;
        } else if (level < FATAL) {
            levelCss = css.levels.error;
        } else {
            levelCss = css.levels.fatal;
        }

        const dateStr = format(time, 'HH:mm:ss.SSS');

        // [time] level: (class): msg
        const msg = `[${dateStr}]%c${formattedLevelName}%c: %c%s%c %c${_msg}`;

        const logArgs = [msg, levelCss, css.default, css.class, component ? `(${component})` : '', loggerName, css.msg];

        if (rest) {
            logArgs.push('\n');
            logArgs.push(rest);
        }

        const err = rec.err as Error;
        if (err?.stack) {
            logArgs.push('\n');
            logArgs.push(err.stack);
        }
        consoleMethod.apply(console, logArgs);
    }
}
